export default "__VITE_ASSET__BmCQuleC__"